import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import heroVideo from "../components/assets/video/hero-video.mp4";
import heroVideoPlaceholder from "../components/assets/placeholder-images-video/thumb homepage.jpg";
import propertyPlaceholder from "../components/assets/images/a43b503cb6f5edaff7aca2b26242b1e68cd11bfc.png";
import madinahHeightsImage from "../components/assets/images/madinah-heights-placeholder.png";
import alMajdiehImage from "../components/assets/images/al-majdieh-placeholder.png";
import heroPlaceholder from "../components/assets/images/hero-placeholder.png";
import apartmentsImage from "../components/assets/images/featured-properties/apartments.png";
import villasImage from "../components/assets/images/featured-properties/villas.png";
import mapDesktopImage from "../components/assets/images/maps/dekstop.jpg";
import mapMobileImage from "../components/assets/images/maps/mobile.jpg";
import section05Image from "../components/assets/images/landing-section5.png";
import logosCollage from "../components/assets/images/Logos_collage.svg";
import heroTextSVG from "../components/assets/images/live in the prophet's city web.svg";
import { ReactComponent as MinistryOfInvestmentLogo } from "../components/assets/images/partner logos/Ministry of Investment.svg";
import { ReactComponent as RuaAlMadinahLogo } from "../components/assets/images/partner logos/Rua al Madinah.svg";
import { ReactComponent as AlMajdiehLogo } from "../components/assets/images/partner logos/Al Majdieh.svg";
import { ReactComponent as KECLogo } from "../components/assets/images/partner logos/KEC.svg";
import { ReactComponent as Vision2030Logo } from "../components/assets/images/partner logos/Vision 2030.svg";
import { ReactComponent as MapPinIcon } from "../components/assets/icons/map-pin.svg";
import { ReactComponent as MosqueIcon } from "../components/assets/icons/icoons/mosque-islam-svgrepo-com 1.svg";
import { ReactComponent as PrayerIcon } from "../components/assets/icons/icoons/islam-muslim-svgrepo-com 1.svg";
import { ReactComponent as PrayerMatIcon } from "../components/assets/icons/icoons/mat-carpet-svgrepo-com 1.svg";
import { ReactComponent as BedIcon } from "../components/assets/icons/bed.svg";
import { ReactComponent as BathtubIcon } from "../components/assets/icons/bathtub.svg";

// Updated logo colors
const logoStyle = { fill: "#6E6E6E" };

function Home() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = "Home | Signature Homes";
  }, []);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="home">
      <section className="hero-section">
        <video
          className="hero-video"
          autoPlay
          loop
          muted
          playsInline
          poster={heroVideoPlaceholder}
          fetchpriority="high"
        >
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay">
          <div className="hero-content">
            <img
              src={heroTextSVG}
              alt="Live in the Prophet's city"
              className="hero-text-svg"
              width="718"
              height="78"
              fetchpriority="high"
            />
            <button 
              className="hero-cta-btn"
              id="hero-cta-btn"
              onClick={() => {
                const featuredSection = document.getElementById('featured-properties-section');
                if (featuredSection) {
                  const navbarHeight = 70; // Navbar height in pixels
                  const elementPosition = featuredSection.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                }
              }}
            >
              Discover homes in Madinah
            </button>
          </div>
        </div>
      </section>

      <section className="move-easy-section">
        <div className="move-easy-container">
          <p className="section-subtitle">
            Offering state-of-the-art properties in Madinah, the holy city, setting the stage for a blessed life for you and your
            family. We'll simplify your journey, providing seamless expert
            assistance from selection to closing.
          </p>

          <div className="divider"></div>

          <h2 className="section-title">We make your move easy</h2>

          <div className="content-wrapper">
            <div className="video-container">
              <iframe
                src="https://player.vimeo.com/video/1158218608?fl=sv&fe=ci&autoplay=0&muted=1&controls=1"
                className="feature-video"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                loading="lazy"
                title="Signature Homes - We make your move easy"
                style={{ display: "block" }}
              ></iframe>
            </div>

            <div className="features-list">
              <ul>
                <li>We'll help your through Saudi foreign Muslim ownership rules</li>
                <li>Select your property</li>
                <li>Receive step-by-step ownership guidance</li>
                <li>Receive your keys</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="featured-properties-section" className="featured-properties-section">
        <div className="featured-properties-container">
          <div className="featured-header">
            <h2 className="featured-title">Featured properties in Madinah</h2>
          </div>

          <div className="properties-grid two-column">
            <div
              className="property-card"
              id="property-card-apartments"
              onClick={() => navigate("/properties/al-majdieh-village-apartments")}
              style={{ cursor: "pointer" }}
            >
              <div className="property-image-wrapper">
                <div className="property-badge high-demand">HIGH DEMAND</div>
                <img
                  src={villasImage}
                  alt="Apartments - Meshraf al-Majdiah"
                  className="property-image"
                  width="600"
                  height="450"
                  loading="lazy"
                />
              </div>
              <div className="property-details">
                <h3 className="property-name">Apartments - Meshraf al-Majdiah</h3>
                <p className="property-location">Madinah | Saudi Arabia</p>
                <p className="property-distance">
                  <MapPinIcon className="map-pin-icon" />12 min drive from Masjid al-Nabawi
                </p>
                <div className="property-info">
                  <div className="property-specs">
                    <div className="specs-group">
                      <div className="spec-item">
                        <BedIcon className="spec-icon" />
                        <span>1-3</span>
                      </div>
                      <div className="spec-item">
                        <BathtubIcon className="spec-icon" />
                        <span>2-3</span>
                      </div>
                    </div>
                    <div className="spec-item">
                      <span className="sqft-label">80.3-145 m²</span>
                    </div>
                  </div>
                  <div className="property-bottom">
                    <div className="property-price">
                      {/* Original price: £95,000 */}
                      <span className="price-amount">
                        From SAR 750,000
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="property-card"
              id="property-card-villas"
              onClick={() => navigate("/properties/al-majdieh-village-villas")}
              style={{ cursor: "pointer" }}
            >
              <div className="property-image-wrapper">
                <div className="property-badge high-demand">HIGH DEMAND</div>
                <img
                  src={apartmentsImage}
                  alt="Villas - Meshraf al-Majdiah"
                  className="property-image"
                  width="600"
                  height="450"
                  loading="lazy"
                />
              </div>
              <div className="property-details">
                <h3 className="property-name">Villas - Meshraf al-Majdiah</h3>
                <p className="property-location">Madinah | Saudi Arabia</p>
                <p className="property-distance">
                  <MapPinIcon className="map-pin-icon" />12 min drive from Masjid al-Nabawi
                </p>
                <div className="property-info">
                  <div className="property-specs">
                    <div className="specs-group">
                      <div className="spec-item">
                        <BedIcon className="spec-icon" />
                        <span>4-6</span>
                      </div>
                      <div className="spec-item">
                        <BathtubIcon className="spec-icon" />
                        <span>7</span>
                      </div>
                    </div>
                    <div className="spec-item">
                      <span className="sqft-label">397 - 410 m²</span>
                    </div>
                  </div>
                  <div className="property-bottom">
                    <div className="property-price">
                      {/* Original price: £420,000 */}
                      <span className="price-amount">
                        From SAR 2,550,000
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <img
          src={isMobile ? mapMobileImage : mapDesktopImage}
          alt="Madinah Map"
          className="map-image"
          width={isMobile ? "768" : "1920"}
          height={isMobile ? "1024" : "800"}
          loading="lazy"
        />
      </section>

      <section className="section05">
        <img
          src={section05Image}
          alt="Section 05"
          className="section05-image"
          width="1920"
          height="600"
          loading="lazy"
        />
      </section>

      <section className="madinah-meaning-section">
        <div className="madinah-meaning-container">
          <h2 className="madinah-meaning-title">
            What it means to live in Madinah
          </h2>

          <div className="madinah-features">
            <div className="madinah-feature">
              <MosqueIcon className="feature-icon" />
              <div className="feature-divider"></div>
              <h3 className="feature-heading">Feel at home</h3>
              <p className="feature-text">
                Madinah offers a calm rhythm of life, genuine community and a
                sense of safety that is deeply rooted.
              </p>
            </div>

            <div className="madinah-feature">
              <PrayerMatIcon className="feature-icon" />
              <div className="feature-divider"></div>
              <h3 className="feature-heading">A spiritual anchor</h3>
              <p className="feature-text">
                Just minutes from Masjid al-Nabawi, creating a unique connection
                between faith, routine and purpose.
              </p>
            </div>

            <div className="madinah-feature">
              <PrayerIcon className="feature-icon" />
              <div className="feature-divider"></div>
              <h3 className="feature-heading">
                A family sanctuary
              </h3>
              <p className="feature-text">
                Choosing Madinah means giving your family a life grounded in
                spirituality, stability and long-term wellbeing.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <div className="partners-container">
          <h2 className="partners-title">Who we work with</h2>

          <div className="partners-divider"></div>

          <p className="partners-text">
          Signature Homes partners with leading and trusted property developer Al Majdiah in Saudi Arabia, offering a wide range of homes to suit diverse needs.
          </p>

          <div className="partners-logos">
            <div className="partner-logo">
              <MinistryOfInvestmentLogo className="logo-svg" />
            </div>
            <div className="partner-logo">
              <AlMajdiehLogo className="logo-svg" />
            </div>
            <div className="partner-logo">
              <KECLogo className="logo-svg" />
            </div>
            <div className="partner-logo">
              <RuaAlMadinahLogo className="logo-svg" />
            </div>
            <div className="partner-logo">
              <Vision2030Logo className="logo-svg" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
